module.exports = __webpack_public_path__ + "img/FK.58bcc5e8.svg";